import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnRadioComponent} from './radio.component';
import {FormsModule} from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';


@NgModule({
  declarations: [GnRadioComponent],
  imports: [
    CommonModule,
    FormsModule,
    NzRadioModule
  ],
  exports: [GnRadioComponent],
  entryComponents: []
})
export class GnRadioModule {
}
